const getStudentsList = state => state?.institute?.studentsList
const getSingleStudentData = state => state?.institute?.singleStudentData
const getStudentMetricsData = state => state?.institute?.studentsMetrics
const getStudentDegreeList = state => state?.institute?.degreeList
const getStudentPendingData = state => state?.institute?.studentPendingData
const getNotificationCatalogueData = state => state?.institute?.notificationCatalogue

const selectors = {
  getStudentsList,
  getSingleStudentData,
  getStudentMetricsData,
  getStudentDegreeList,
  getStudentPendingData,
  getNotificationCatalogueData
}

export default selectors
